import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';
import SchedulesElaborateBasesDates from './SchedulesElaborateBasesDates';
import SchedulesElaborateBasesTotal from './SchedulesElaborateBasesTotal';

class SchedulesElaborateBases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      show: this.props.show,
      data: this.props.data,
      total_ano: this.props.total_ano,
      schedule: {},
    };

    this.locale = getLocale();
  }
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && newProps.show !== 0)) {
      this.setState({
        data: newProps.data,
        total_ano: newProps.total_ano,
        schedule: newProps.schedule,
        show: newProps.show,
        loaded: 1,
      });
    } else if(newProps.show === 0) {
      this.setState({loaded: 0});
      this.setState({show: 0});
      this.setState({data: []});
      this.setState({total_ano: []});
      this.setState({schedule: []});
    }
  }

  render() {
    var self = this;
    var key_control = 0;
    return (
<div>
  {(self.state.show === 1) ? 
    <div>
      <h3>{this.locale.Escalas.ElaboracaoDeEscala.tituloElaboraçãoDeEscalaBases} <small> - {self.state.schedule['name'] + ' - ' + self.state.schedule['aircraft_model']['model']}</small></h3>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        {Object.keys(self.state.data).map(function(k) {
          key_control++;
          return (
            <Tab eventKey={key_control} title={self.state.data[k].infos.name}>
              <SchedulesElaborateBasesDates data={self.state.data[k]} />
            </Tab>
          );
        })}
        <Tab eventKey={key_control + 1} title={this.locale.Escalas.ElaboracaoDeEscala.tabTotaisDoPeriodo.tituloTab}>
          <SchedulesElaborateBasesTotal data={self.state.total_ano} schedule={self.state.schedule} />
        </Tab>
      </Tabs>
    </div>
    : ''
  }
</div>
    );
  }
}

export default SchedulesElaborateBases;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesElaborateBases.js